<template>
    <div v-if="isActive" :class="[className]">
        <div
            v-if="showFeedbackOptions"
            class="d-flex flex-row justify-content-center align-items-center alert"
            role="alert">
            <div class="content d-flex flex-nowrap justify-content-between align-items-center">
                <i v-if="helpFeedback"
                    :title="helpFeedback"
                    data-toggle="tooltip-city"
                    data-html="true"
                    class="pr-3 far fa-question-circle"></i>
                <span class="description" v-if="descriptionFeedback" v-html="descriptionFeedback"></span>
            </div>
            <div class="btn-group" role="group" aria-label="Tools group">
                <button
                    v-for="(tool, idx) in tools"
                    :key="`feedback-tool-${idx}`"
                    type="button"
                    class="btn btn-link btn-rounded min-w-auto"
                    data-toggle="tooltip-city"
                    data-html="true"
                    :title="$t(tool.title)"
                    @click.prevent="onClickTool(tool)">
                    <i v-if="tool.icon" :class="[tool.icon, tool.class]"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import GlobalMixin from '@/app/shared/mixins/global';
    import { isFunction, isArray, isObject } from '@config/utils';
    import { mapGetters } from "vuex";

    export default {
        mixins: [
            GlobalMixin,
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'feedbackoptions',
                className: 'ol-feedbackoptions',
            }
        },
        computed: {
            ...mapGetters({
                isActive: 'feedbackOptionsActive',
                description: 'feedbackOptionsDescription',
                help: 'feedbackOptionsHelp',
                tools: 'feedbackOptionsTools',
                callback: 'feedbackOptionsCallback',
            }),
            showFeedbackOptions() {
                return this.isActive;
            },
            descriptionFeedback() {
                return this.description;
            },
            helpFeedback() {
                let help = this.help;
                if(help) {
                    help = isObject(help) ? Object.values(help) : help;
                    if(isObject(help)) {
                        help = Object.values(help);
                    }
                    if(isArray(help)) {
                        help = help.map(txt => {
                            return `<li>${txt}</li>`;
                        });
                        help.unshift('<ol class="m-0 pl-3 text-left">');
                        help.push('</ol>');
                        help = help.join('');
                    }
                }
                return help;
            }
        },
        methods: {
            addButtonMap: function(_map){
                return false;
            },
            initialize: function() {
                this.$nextTick(() => {
                    this.activeTooltip();
                });
            },
            reset: function() {
                this.hideTooltip();
            },
            onClickTool: function(tool) {
                this.reset();

                let fn = this.callback;
                if (typeof fn !== 'undefined' && isFunction(fn)) {
                    return fn.call(tool, {
                        value: tool.value
                    });
                }
            }
        },
        watch: {
            showFeedbackOptions: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.initialize();
                    }else{
                        this.reset();
                    }
                },
            },
        }
    }
</script>